/**
 * @generated SignedSource<<23b8ab3dd7e7752a0968881a6a300380>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RegionSidebar_region$data = {
  readonly " $fragmentSpreads": FragmentRefs<"EntitySidebar_entity">;
  readonly " $fragmentType": "RegionSidebar_region";
};
export type RegionSidebar_region$key = {
  readonly " $data"?: RegionSidebar_region$data;
  readonly " $fragmentSpreads": FragmentRefs<"RegionSidebar_region">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RegionSidebar_region",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EntitySidebar_entity"
    }
  ],
  "type": "Region",
  "abstractKey": null
};

(node as any).hash = "79c9969cd734d43b8c3b96c2fe92e3e3";

export default node;
